export const historyMovementsViewInitValue = {
  data: {
    expandView: false,
    expandDirection: 'down',
    historyMovements: [],
    totalHistoryMovements: 0,
    page: 1,
    rowsPerPage: 5,
    operationType: '',
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleChangeExpandView: () => {},
  },
};
